/**
 * @description
 */

import Api from '../../path';
import { ECollectionType } from '@umu/umu-types';
import { fetchData } from '@umu/umu-fetch';

// 判断对象是否被收藏（批量）
export interface IInputMulti {
    obj_type: ECollectionType;
    obj_ids: string;
}

export type IOutputMulti = IResponse<{ [name: string]: 0 | 1 } | {}>;

// 获取多个小节是否收藏
export const getISCollectedMulti = (data: IInputMulti) => {
    return fetchData(Api.IS_COLLECTED_MULTI, data).then((res: IOutputMulti) => {
        return res;
    });
};
